import { Point } from '../../src';

interface CitySeries {
  data: Point[];
  dist: { anchor: Point; ranges: number[] };
  key: string;
  meta: { seriesName: string };
}

export const rain: Array<CitySeries> = [
  {
    data: [
      [0, 5.67],
      [0, 6.63],
      [0, 8.05],
      [0, 8.33],
      [0, 8.35],
      [0, 8.42],
      [0, 8.44],
      [0, 8.46],
      [0, 8.48],
      [0, 8.82],
      [0, 9.08],
      [0, 9.47],
      [0, 9.76],
      [0, 11.2],
      [0, 11.27],
      [0, 11.28],
      [0, 11.39],
      [0, 12.05],
      [0, 12.22],
      [0, 12.25],
      [0, 12.44],
      [0, 12.72],
      [0, 13.02],
      [0, 13.17],
      [0, 13.43],
      [0, 13.5],
      [0, 14.68],
      [0, 14.73],
      [0, 14.84],
      [0, 15.2],
      [0, 15.24],
      [0, 15.35],
      [0, 15.57],
      [0, 15.77],
      [0, 15.87],
      [0, 15.95],
      [0, 16.01],
      [0, 16.35],
      [0, 16.45],
      [0, 16.55],
      [0, 16.62],
      [0, 16.66],
      [0, 16.68],
      [0, 16.72],
      [0, 17.05],
      [0, 17.19],
      [0, 17.22],
      [0, 17.26],
      [0, 17.36],
      [0, 17.56],
      [0, 17.6],
      [0, 17.89],
      [0, 18.1],
      [0, 18.53],
      [0, 19.15],
      [0, 19.4],
      [0, 19.64],
      [0, 19.89],
      [0, 19.9],
      [0, 20.07],
      [0, 20.12],
      [0, 20.17],
      [0, 20.26],
      [0, 20.51],
      [0, 20.54],
      [0, 20.58],
      [0, 20.61],
      [0, 20.79],
      [0, 20.98],
      [0, 20.99],
      [0, 21.03],
      [0, 21.05],
      [0, 21.07],
      [0, 21.07],
      [0, 21.11],
      [0, 21.24],
      [0, 21.68],
      [0, 21.74],
      [0, 22.01],
      [0, 22.5],
      [0, 22.72],
      [0, 22.82],
      [0, 23.06],
      [0, 23.1],
      [0, 23.6],
      [0, 23.65],
      [0, 23.94],
      [0, 24.3],
      [0, 24.38],
      [0, 24.42],
      [0, 24.49],
      [0, 24.58],
      [0, 24.69],
      [0, 24.95],
      [0, 25.09],
      [0, 25.33],
      [0, 25.6],
      [0, 25.82],
      [0, 25.96],
      [0, 25.97],
      [0, 26.33],
      [0, 27.52],
      [0, 27.79],
      [0, 28.26],
      [0, 29.47],
      [0, 29.87],
      [0, 30.13],
      [0, 30.2],
      [0, 30.36],
      [0, 30.4],
      [0, 31.13],
      [0, 31.5],
      [0, 31.83],
      [0, 35.83],
      [0, 36.02],
      [0, 36.34],
      [0, 36.71],
      [0, 37.93],
      [0, 38.03],
      [0, 40.01],
      [0, 40.86],
      [0, 42.29],
      [0, 42.85],
      [0, 43.86],
      [0, 44.99],
      [0, 46.16],
      [0, 49.1],
      [0, 57.39],
      [0, 59.79],
      [0, 60.61],
      [0, 61.23],
      [0, 61.31],
      [0, 61.54],
      [0, 62.63],
      [0, 62.9],
      [0, 63.51],
      [0, 63.96],
      [0, 64],
      [0, 64],
      [0, 66.44],
      [0, 67.17],
      [0, 67.33],
      [0, 67.39],
      [0, 67.84],
      [0, 68.52],
      [0, 69.22],
      [0, 69.38],
      [0, 70.28],
      [0, 70.57],
      [0, 70.68],
      [0, 70.86],
      [0, 70.96],
      [0, 72.87],
      [0, 72.94],
      [0, 73.75],
      [0, 74.19],
      [0, 74.73],
      [0, 74.78],
      [0, 75.51],
      [0, 75.54],
      [0, 76.07],
      [0, 76.57],
      [0, 77.57],
      [0, 77.65],
      [0, 78.22],
      [0, 78.29],
      [0, 78.75],
      [0, 79.39],
      [0, 79.74],
      [0, 79.76],
      [0, 80.03],
      [0, 80.96],
      [0, 81.43],
      [0, 81.8],
      [0, 81.85],
      [0, 82.84],
      [0, 83.49],
      [0, 85.09],
      [0, 85.1],
      [0, 85.89],
      [0, 87.43],
      [0, 88.24],
      [0, 88.85],
      [0, 89.09],
      [0, 89.18],
      [0, 90.72],
      [0, 90.83],
      [0, 91.56],
      [0, 102.82],
      [0, 106.94],
      [0, 108.75],
      [0, 114.92],
      [0, 115.72],
      [0, 116.6],
      [0, 117.99],
      [0, 122.51],
      [0, 123.96],
      [0, 124.55],
      [0, 124.59],
      [0, 125.25],
      [0, 126.18],
      [0, 126.49],
      [0, 127.29],
      [0, 130.19],
      [0, 130.4],
      [0, 132.17],
      [0, 132.34],
      [0, 132.88],
      [0, 133.5],
      [0, 135.05],
      [0, 135.29],
      [0, 138.49],
      [0, 138.74],
      [0, 139.45],
      [0, 140.06],
      [0, 140.14],
      [0, 142.05],
      [0, 142.2],
      [0, 142.93],
      [0, 143.22],
      [0, 143.42],
      [0, 143.54],
      [0, 143.64],
      [0, 143.74],
      [0, 144.49],
      [0, 144.59],
      [0, 144.61],
      [0, 145.6],
      [0, 149.13],
      [0, 149.13],
      [0, 149.66],
      [0, 151.45],
      [0, 151.98],
      [0, 152.16],
      [0, 152.38],
      [0, 156.62],
      [0, 158.5],
      [0, 161.74],
      [0, 162.27],
      [0, 166.42],
      [0, 168.41],
      [0, 169.32],
      [0, 169.93],
      [0, 170.2],
      [0, 175.15],
      [0, 175.33],
      [0, 176.5],
      [0, 176.9],
      [0, 178.8],
      [0, 180.43],
      [0, 184.14],
      [0, 189.77],
    ],
    key: 'Vancouver',
    meta: { seriesName: 'Vancouver' },
    dist: {
      anchor: [0, 49.1],
      ranges: [5.67, 20.51, 49.1, 106.94, 189.77],
    },
  },
  {
    data: [
      [1, 16.68],
      [1, 17.95],
      [1, 20.07],
      [1, 20.64],
      [1, 20.71],
      [1, 22.58],
      [1, 23.17],
      [1, 23.64],
      [1, 24.2],
      [1, 24.66],
      [1, 25.18],
      [1, 25.22],
      [1, 25.59],
      [1, 26.23],
      [1, 26.78],
      [1, 27.05],
      [1, 27.5],
      [1, 27.95],
      [1, 28.18],
      [1, 28.18],
      [1, 28.31],
      [1, 29.04],
      [1, 29.09],
      [1, 29.13],
      [1, 30.56],
      [1, 30.94],
      [1, 30.97],
      [1, 31.05],
      [1, 31.43],
      [1, 31.66],
      [1, 31.96],
      [1, 32.27],
      [1, 32.7],
      [1, 33.49],
      [1, 34.37],
      [1, 34.94],
      [1, 35.22],
      [1, 35.39],
      [1, 36.05],
      [1, 36.85],
      [1, 38.03],
      [1, 38.05],
      [1, 38.54],
      [1, 39.21],
      [1, 39.4],
      [1, 39.76],
      [1, 39.99],
      [1, 40.56],
      [1, 40.56],
      [1, 40.93],
      [1, 41.84],
      [1, 41.94],
      [1, 42.73],
      [1, 42.82],
      [1, 42.89],
      [1, 43.09],
      [1, 43.09],
      [1, 43.15],
      [1, 43.58],
      [1, 43.67],
      [1, 43.71],
      [1, 44.16],
      [1, 44.66],
      [1, 45],
      [1, 45.4],
      [1, 45.84],
      [1, 46.15],
      [1, 46.26],
      [1, 46.48],
      [1, 46.65],
      [1, 46.77],
      [1, 47.29],
      [1, 47.75],
      [1, 48.14],
      [1, 48.87],
      [1, 48.97],
      [1, 49.41],
      [1, 49.6],
      [1, 49.74],
      [1, 50.34],
      [1, 50.35],
      [1, 51.1],
      [1, 51.76],
      [1, 51.79],
      [1, 52.13],
      [1, 53.1],
      [1, 53.34],
      [1, 53.71],
      [1, 53.72],
      [1, 55.1],
      [1, 55.84],
      [1, 56.14],
      [1, 56.89],
      [1, 57.44],
      [1, 58],
      [1, 59.17],
      [1, 59.23],
      [1, 60.47],
      [1, 60.62],
      [1, 60.87],
      [1, 61.09],
      [1, 61.27],
      [1, 61.8],
      [1, 63.73],
      [1, 63.74],
      [1, 63.91],
      [1, 65.28],
      [1, 65.54],
      [1, 66.87],
      [1, 68.49],
      [1, 69.05],
      [1, 70.28],
      [1, 71.24],
      [1, 72.05],
      [1, 74.82],
      [1, 76.85],
      [1, 76.91],
      [1, 77.93],
      [1, 78.32],
      [1, 80.02],
      [1, 85.31],
      [1, 85.33],
      [1, 86.99],
      [1, 88.16],
      [1, 89.64],
      [1, 90.64],
      [1, 92.89],
      [1, 98.87],
      [1, 101.23],
      [1, 103.14],
      [1, 103.64],
      [1, 105.3],
      [1, 105.36],
      [1, 106.07],
      [1, 107.55],
      [1, 109.39],
      [1, 109.95],
      [1, 111.03],
      [1, 111.32],
      [1, 112.22],
      [1, 112.26],
      [1, 112.72],
      [1, 113.28],
      [1, 113.3],
      [1, 114.24],
      [1, 114.77],
      [1, 115.01],
      [1, 115.63],
      [1, 116.47],
      [1, 116.8],
      [1, 117.2],
      [1, 117.42],
      [1, 117.74],
      [1, 118.58],
      [1, 118.99],
      [1, 119.03],
      [1, 119.48],
      [1, 120.93],
      [1, 121.03],
      [1, 122.35],
      [1, 123.43],
      [1, 123.64],
      [1, 124.24],
      [1, 125.04],
      [1, 126.67],
      [1, 128.23],
      [1, 128.37],
      [1, 128.41],
      [1, 128.43],
      [1, 128.51],
      [1, 129.44],
      [1, 130.35],
      [1, 132.63],
      [1, 132.95],
      [1, 133.62],
      [1, 136.17],
      [1, 137.8],
      [1, 137.87],
      [1, 139.39],
      [1, 139.79],
      [1, 139.81],
      [1, 139.82],
      [1, 140.16],
      [1, 144.77],
      [1, 147.08],
      [1, 147.59],
      [1, 149.2],
      [1, 151.7],
      [1, 153.55],
      [1, 153.74],
      [1, 154.24],
      [1, 154.78],
      [1, 158.34],
      [1, 160.16],
      [1, 162.16],
      [1, 163.5],
      [1, 163.6],
      [1, 164.84],
      [1, 165.14],
      [1, 166.34],
      [1, 171.26],
      [1, 172.66],
      [1, 173.28],
      [1, 173.41],
      [1, 174.11],
      [1, 174.98],
      [1, 175.4],
      [1, 180.43],
      [1, 180.58],
      [1, 183.01],
      [1, 184.08],
      [1, 184.53],
      [1, 184.56],
      [1, 184.72],
      [1, 184.8],
      [1, 187.37],
      [1, 187.43],
      [1, 187.68],
      [1, 189.72],
      [1, 189.85],
      [1, 191.19],
      [1, 191.83],
      [1, 192.64],
      [1, 193.18],
      [1, 195.4],
      [1, 196.29],
      [1, 196.49],
      [1, 197.49],
      [1, 197.7],
      [1, 199.32],
      [1, 199.93],
      [1, 201.78],
      [1, 202.23],
      [1, 202.36],
      [1, 205.79],
      [1, 207.2],
      [1, 208.1],
      [1, 208.28],
      [1, 210.39],
      [1, 210.97],
      [1, 212.96],
      [1, 213.77],
      [1, 215.82],
      [1, 219.65],
      [1, 224.45],
      [1, 225.28],
      [1, 230.62],
      [1, 231.38],
      [1, 237.64],
      [1, 237.78],
      [1, 238.8],
      [1, 242.25],
    ],
    key: 'Victoria',
    meta: { seriesName: 'Victoria' },
    dist: {
      anchor: [1, 92.89],
      ranges: [16.68, 45, 92.89, 153.74, 242.25],
    },
  },
  {
    data: [
      [2, 10.87],
      [2, 11.04],
      [2, 11.33],
      [2, 12.43],
      [2, 12.7],
      [2, 13.18],
      [2, 13.6],
      [2, 13.9],
      [2, 13.95],
      [2, 13.99],
      [2, 14.07],
      [2, 14.22],
      [2, 14.38],
      [2, 14.38],
      [2, 14.73],
      [2, 14.74],
      [2, 14.8],
      [2, 14.85],
      [2, 14.97],
      [2, 15.09],
      [2, 15.27],
      [2, 15.54],
      [2, 15.71],
      [2, 15.71],
      [2, 15.73],
      [2, 15.82],
      [2, 15.84],
      [2, 15.94],
      [2, 15.95],
      [2, 15.98],
      [2, 16.06],
      [2, 16.12],
      [2, 16.17],
      [2, 16.25],
      [2, 16.32],
      [2, 16.37],
      [2, 16.43],
      [2, 16.47],
      [2, 16.53],
      [2, 16.55],
      [2, 16.56],
      [2, 16.7],
      [2, 16.73],
      [2, 16.9],
      [2, 16.92],
      [2, 16.92],
      [2, 17.04],
      [2, 17.06],
      [2, 17.09],
      [2, 17.22],
      [2, 17.25],
      [2, 17.26],
      [2, 17.3],
      [2, 17.3],
      [2, 17.33],
      [2, 17.48],
      [2, 17.62],
      [2, 17.65],
      [2, 17.84],
      [2, 17.87],
      [2, 17.92],
      [2, 17.97],
      [2, 18],
      [2, 18],
      [2, 18.03],
      [2, 18.05],
      [2, 18.15],
      [2, 18.23],
      [2, 18.32],
      [2, 18.39],
      [2, 18.41],
      [2, 18.45],
      [2, 18.62],
      [2, 18.65],
      [2, 18.72],
      [2, 19.03],
      [2, 19.11],
      [2, 19.12],
      [2, 19.32],
      [2, 19.37],
      [2, 19.37],
      [2, 19.41],
      [2, 19.66],
      [2, 19.67],
      [2, 19.71],
      [2, 19.83],
      [2, 19.84],
      [2, 19.85],
      [2, 19.96],
      [2, 20],
      [2, 20.17],
      [2, 20.22],
      [2, 20.27],
      [2, 20.29],
      [2, 20.3],
      [2, 20.4],
      [2, 20.43],
      [2, 20.49],
      [2, 20.49],
      [2, 20.56],
      [2, 20.57],
      [2, 20.71],
      [2, 20.8],
      [2, 20.82],
      [2, 20.88],
      [2, 20.91],
      [2, 21.01],
      [2, 21.09],
      [2, 21.58],
      [2, 21.63],
      [2, 21.94],
      [2, 22.18],
      [2, 22.73],
      [2, 22.77],
      [2, 22.83],
      [2, 22.86],
      [2, 22.91],
      [2, 23.29],
      [2, 23.3],
      [2, 23.43],
      [2, 23.59],
      [2, 23.94],
      [2, 24.06],
      [2, 24.21],
      [2, 24.21],
      [2, 24.71],
      [2, 24.74],
      [2, 24.98],
      [2, 25.03],
      [2, 25.24],
      [2, 25.25],
      [2, 25.37],
      [2, 25.68],
      [2, 25.78],
      [2, 25.93],
      [2, 26.14],
      [2, 26.45],
      [2, 26.52],
      [2, 26.99],
      [2, 27.38],
      [2, 27.54],
      [2, 27.59],
      [2, 27.92],
      [2, 27.99],
      [2, 28.16],
      [2, 28.17],
      [2, 28.31],
      [2, 28.34],
      [2, 29.15],
      [2, 29.26],
      [2, 29.81],
      [2, 29.9],
      [2, 29.92],
      [2, 30.01],
      [2, 30.22],
      [2, 30.35],
      [2, 30.59],
      [2, 30.72],
      [2, 30.88],
      [2, 30.94],
      [2, 31.33],
      [2, 31.45],
      [2, 31.83],
      [2, 32.02],
      [2, 32.1],
      [2, 32.45],
      [2, 32.55],
      [2, 32.62],
      [2, 32.8],
      [2, 32.87],
      [2, 32.91],
      [2, 33.12],
      [2, 33.55],
      [2, 33.57],
      [2, 33.96],
      [2, 33.98],
      [2, 34.11],
      [2, 34.12],
      [2, 34.13],
      [2, 34.32],
      [2, 34.51],
      [2, 34.54],
      [2, 34.59],
      [2, 34.73],
      [2, 34.75],
      [2, 34.82],
      [2, 34.92],
      [2, 35.04],
      [2, 35.14],
      [2, 35.15],
      [2, 35.19],
      [2, 35.51],
      [2, 35.62],
      [2, 36.01],
      [2, 36.04],
      [2, 36.04],
      [2, 36.37],
      [2, 36.44],
      [2, 36.59],
      [2, 36.72],
      [2, 36.93],
      [2, 37.08],
      [2, 37.71],
      [2, 37.87],
      [2, 37.93],
      [2, 37.94],
      [2, 38.19],
      [2, 38.38],
      [2, 38.57],
      [2, 38.83],
      [2, 39.15],
      [2, 39.19],
      [2, 39.25],
      [2, 39.38],
      [2, 39.41],
      [2, 39.58],
      [2, 39.76],
      [2, 39.85],
      [2, 40.07],
      [2, 40.34],
      [2, 40.35],
      [2, 40.54],
      [2, 40.62],
      [2, 40.63],
      [2, 40.74],
      [2, 41.03],
      [2, 41.17],
      [2, 41.29],
      [2, 41.35],
      [2, 41.47],
      [2, 41.56],
      [2, 41.56],
      [2, 42.04],
      [2, 42.39],
      [2, 42.55],
      [2, 42.83],
      [2, 43.11],
      [2, 43.67],
      [2, 43.7],
      [2, 43.92],
      [2, 43.94],
      [2, 44.16],
      [2, 44.41],
      [2, 44.63],
      [2, 46.13],
      [2, 46.93],
      [2, 47.1],
      [2, 47.65],
      [2, 48.37],
      [2, 50.3],
      [2, 50.71],
      [2, 54.96],
    ],
    key: 'Kelowna',
    meta: { seriesName: 'Kelowna' },
    dist: { anchor: [2, 24.74], ranges: [10.87, 18, 24.74, 35.15, 54.96] },
  },
];
